//---- components ---------
//---- mixins -------------
//---- services -----------
import DraftService from '../services/draft.service.js';
//---- other --------------
//---- 3rd-parties --------

export const initialState = {
    draftCases: [],
    openedDraftId: null
}

export const draft = {
    //---------------- namespaced --------------------------------------------
    namespaced: true,
    //----------------- state ------------------------------------------------
    state: { ...initialState },
    //----------------- vuex actions  ----------------------
    actions: {
        // get draft cases data
        getDraftCases({ commit }) {
            DraftService.getDraftCases().then(response => {
                if (response) {
                    commit('setDraftCases', response.data.draftCases)
                }
            })
        },
    },
    //---------------------mutations ----------------------------------------------
    mutations: {
        setDraftCases(state, draftCases) {
            state.draftCases = draftCases;
        },
        error(state) {
            state.draftCases = null;
            state.openedDraftId = null;
        }
    },

    //--------------------- getters ------------------------------------------------
    getters: {
        openedDraftId: (state) => {
            return state.openedDraftId;
        },
        draftCases: (state) => {
            return state.draftCases;
        },
        hasDraftCases: (state) => {
            return state.draftCases?.length > 0;
        },
    }
}